// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-reg-email{width:760px}.send-reg-email .modal__header{margin-bottom:20px}.send-reg-email .fr-box{line-height:1.5}`, "",{"version":3,"sources":["webpack://./src/modals/SendRegEmail/style.scss"],"names":[],"mappings":"AACA,gBACE,WAAA,CAEA,+BACE,kBAAA,CAGF,wBACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
